module.exports = {};
module.exports['29.0.0'] = require('./versionUpdates/29.0.0.js');
module.exports['28.0.0'] = require('./versionUpdates/28.0.0.js');
module.exports['26.0.0'] = require('./versionUpdates/26.0.0.js');
module.exports['25.0.0'] = require('./versionUpdates/25.0.0.js');
module.exports['24.0.0'] = require('./versionUpdates/24.0.0.js');
module.exports['23.0.0'] = require('./versionUpdates/23.0.0.js');
module.exports['22.0.0'] = require('./versionUpdates/22.0.0.js');
